/** Внутренний id этапа (не показывается в UI). UUID hex — уникален в рамках списка. */
const STAGE_ID_RE = /^(?:[a-z0-9_]{1,50}|[a-f0-9]{32})$/

export function createKanbanStageId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID().replace(/-/g, '')
  }
  return `s${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`
}

export function isKanbanStageId(id) {
  return STAGE_ID_RE.test(String(id || '').trim())
}

/** Название этапа по id (для таблицы и подсказок). */
export function resolveKanbanStageTitle(stages, stateId) {
  const id = String(stateId || '').trim()
  if (!id) return ''
  const stage = (stages || []).find((s) => String(s.id || '').trim() === id)
  return stage?.title ? String(stage.title).trim() : id
}

/** Статус тендера в конкретном списке: подпись и цвет этапа. */
export function resolveKanbanStatusForList(row, listId, listMeta) {
  const lid = String(listId || '').trim()
  if (!lid || lid === 'history' || lid.startsWith('preset:')) {
    return { label: '', color: '' }
  }
  const lists = Array.isArray(row?.lists) ? row.lists : []
  const item = lists.find((l) => String(l.id ?? l.list_id ?? '').trim() === lid)
  const stateId = String(item?.state ?? '').trim()
  if (!stateId) return { label: '', color: '' }
  const stages = Array.isArray(listMeta?.kanbanStages) ? listMeta.kanbanStages : []
  const stage = stages.find((s) => String(s.id || '').trim() === stateId)
  return {
    label: resolveKanbanStageTitle(stages, stateId),
    color: stage?.color ? String(stage.color).trim() : '#64748b',
  }
}

/** Сортировка по полю order (для отображения в настройках и канбане). */
export function sortKanbanStagesByOrder(rows) {
  return [...(rows || [])].sort(
    (a, b) => (Number(a?.order) || 0) - (Number(b?.order) || 0)
  )
}

/** Проставить order = 0..n-1 по текущему порядку массива. */
export function applyKanbanStageOrder(rows) {
  ;(rows || []).forEach((row, i) => {
    if (row && typeof row === 'object') row.order = i
  })
  return rows
}

/** Переместить этап с fromIndex на toIndex (мутирует массив). */
export function moveKanbanStage(rows, fromIndex, toIndex) {
  if (!rows?.length || fromIndex === toIndex) return rows
  if (fromIndex < 0 || toIndex < 0 || fromIndex >= rows.length || toIndex >= rows.length) {
    return rows
  }
  const [item] = rows.splice(fromIndex, 1)
  rows.splice(toIndex, 0, item)
  return applyKanbanStageOrder(rows)
}

/** Подготовка этапов к отправке на API: сохраняем существующие id, для новых — генерируем. */
export function serializeKanbanStages(rows) {
  const out = []
  const seen = new Set()
  for (let i = 0; i < (rows || []).length; i++) {
    const row = rows[i]
    let id = String(row?.id || '').trim()
    if (!id || !isKanbanStageId(id) || seen.has(id)) {
      do {
        id = createKanbanStageId()
      } while (seen.has(id))
    }
    seen.add(id)
    out.push({
      id,
      title: String(row?.title || '').trim() || 'Этап',
      color: String(row?.color || '').trim() || '#64748b',
      order: i,
    })
  }
  return out
}
